<template>
    <div>
        <!-- website url -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label 
                        for="domain-select" 
                        class="cursor-pointer"
                    >
                        Website URL <span class="text-danger font-weight-bold">*</span>
                    </label>
                    <d-form-select 
                        id="domain-select"
                        v-model="utmTagData.url"
                    >
                        <option value="">
                            Select a website
                        </option>
                        <option 
                            v-for="website in getDomainOptions" 
                            :key="website.id" 
                            :value="website.domain" 
                        >
                            {{ website.domain }}
                        </option>
                    </d-form-select>
                </div>
            </div>
        </div>
        
        <!-- Campaign page -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="medium-input" class="cursor-pointer">
                        Campaign Page
                    </label>
                    <d-input 
                        id="page-input" 
                        placeholder="Page"
                        @keydown.native.space.prevent
                        v-model="utmTagData.page"
                    />
                </div>
            </div>
        </div>

        <!-- Campaign source -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label 
                        for="source-select" 
                        class="cursor-pointer"
                    >
                       Campaign Source <span class="text-danger font-weight-bold">*</span>
                    </label>
                    <d-form-select 
                        id="source-select"
                        v-model="sourceSelect"
                        @change="checkSourceInput"
                    >
                        <option 
                            v-for="source in CampaignSourcesModel" 
                            :key="source.value" 
                            :value="source.value" 
                        >
                            {{ source.label }}
                        </option>
                    </d-form-select>
                </div>
            </div>
        </div>

        <div v-if="isSourceOtherInputFieldOpen" class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="source-input" class="cursor-pointer">
                        What source do you like to add?
                    </label>
                    <d-input 
                        id="source-input" 
                        placeholder="Source"
                        v-model="utmTagData.source"
                    />
                </div>
            </div>
        </div>
        <!-- Campaign medium -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label 
                        for="medium-select" 
                        class="cursor-pointer"
                    >
                       Campaign Medium <span class="text-danger font-weight-bold">*</span>
                    </label>
                    <d-form-select 
                        id="medium-select"
                        v-model="mediumSelect"
                        @change="checkMediumInput"
                    >
                        <option 
                            v-for="medium in CampaignMediumModel" 
                            :key="medium.value" 
                            :value="medium.value" 
                        >
                            {{ medium.label }}
                        </option>
                    </d-form-select>
                </div>
            </div>
        </div>

        <div v-if="isMediumOtherInputFieldOpen" class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="medium-input" class="cursor-pointer">
                        What medium do you like to add?
                    </label>
                    <d-input 
                        id="medium-input" 
                        placeholder="medium"
                        v-model="utmTagData.medium"
                    />
                </div>
            </div>
        </div>
        <!-- Campaign name -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="medium-input" class="cursor-pointer">
                        Campaign Name <span class="text-danger font-weight-bold">*</span>
                    </label>
                    <d-input 
                        id="name-input" 
                        placeholder="Name"
                        v-model="utmTagData.name"
                    />
                </div>
            </div>
        </div>
        <!-- Campaign term -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="medium-input" class="cursor-pointer">
                        Campaign Term
                    </label>
                    <d-input 
                        id="term-input" 
                        placeholder="Term"
                        v-model="utmTagData.term"
                    />
                </div>
            </div>
        </div>
        <!-- Campaign content -->
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="medium-input" class="cursor-pointer">
                        Campaign Content
                    </label>
                    <d-input 
                        id="content-input" 
                        placeholder="Content"
                        v-model="utmTagData.content"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CampaignSourcesModel from '@/models/tools/utm-tag-builder/CampaignSources.model';
    import CampaignMediumModel from '@/models/tools/utm-tag-builder/CampaignMediums.model';
    import { WebsiteService } from '@/main'

    export default {
        data() {
            return {
                sourceSelect: '',
                isSourceOtherInputFieldOpen: false,
                mediumSelect: '',
                isMediumOtherInputFieldOpen: false,
                utmTagData: {
                    url: '',
                    page: '',
                    source: '',
                    medium: '',
                    name: '',
                    term: '',
                    content: '',
                },
                CampaignSourcesModel: CampaignSourcesModel,
                CampaignMediumModel: CampaignMediumModel
            }
        },

        watch: {
            utmTagData: {
                deep: true,
                handler() {
                    this.updateLinkGenerator();
                }
            }
        },

        asyncComputed: {
            async getDomainOptions() {
                return await WebsiteService.get();
            }
        },

        methods: {
            updateLinkGenerator() {
                this.$eventHub.$emit('update-link-generator', this.utmTagData);
            },
            checkSourceInput(value) {
                if (value === 'other') {
                    this.isSourceOtherInputFieldOpen = true;
                    this.utmTagData.source = '';
                } else {
                    this.isSourceOtherInputFieldOpen = false;
                    this.utmTagData.source = value;
                }
            },
            checkMediumInput(value) {
                if (value === 'other') {
                    this.isMediumOtherInputFieldOpen = true;
                    this.utmTagData.medium = '';
                } else {
                    this.isMediumOtherInputFieldOpen = false;
                    this.utmTagData.medium = value;
                }
            }
        },

        mounted() {
            this.updateLinkGenerator()
        }
    }
</script>